import {
  type UserOrderResponseWithFlagsSubOrdersInner,
  type UserSubOrderV2,
  UserSubOrderV2EnrichedStatusEnum,
} from '@redteclab/api/clients/bully'

import { userSubOrderAccessorIsCancellationRequested } from './userSubOrderAccessor'

type SubOrderOrderModificationSelfServiceAvailability = 'enabled' | 'hidden'

export const subOrderStatusAccessorGetOrderModificationSelfServiceAvailability =
  (
    subOrder: UserOrderResponseWithFlagsSubOrdersInner | UserSubOrderV2,
  ): SubOrderOrderModificationSelfServiceAvailability => {
    if (userSubOrderAccessorIsCancellationRequested(subOrder)) {
      return 'hidden'
    }

    switch (subOrder.enrichedStatus) {
      case UserSubOrderV2EnrichedStatusEnum.Canceled:
      case UserSubOrderV2EnrichedStatusEnum.CancelRequested:
      case UserSubOrderV2EnrichedStatusEnum.Closed:
      case UserSubOrderV2EnrichedStatusEnum.Completed:
      case UserSubOrderV2EnrichedStatusEnum.Dispatched:
      case UserSubOrderV2EnrichedStatusEnum.ReadyForPickup: {
        return 'hidden'
      }
      case UserSubOrderV2EnrichedStatusEnum.New:
      case UserSubOrderV2EnrichedStatusEnum.Processing:
      case UserSubOrderV2EnrichedStatusEnum.WaitingForPrepayment: {
        return 'enabled'
      }
      default: {
        return 'hidden'
      }
    }
  }
